export const version = '2.0.0-canary.7e587b0613f8'
